module.exports = __webpack_public_path__ + "static/media/5.26d65409.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/5.png
// module id = 474
// module chunks = 0